if (!customElements.get('cooldo-broth-gallery')) {
  customElements.define('cooldo-broth-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('[data-broth-track]');
      const slides = [...this.querySelectorAll('[data-broth-slide]')];
      const dialog = this.querySelector('dialog');
      const enlarged = this.querySelector('[data-broth-enlarged]');
      const shortcuts = [...this.querySelectorAll('[data-broth-index]')];
      let index = 0;
      let enlargedIndex = 0;
      const showEnlarged = next => {
        enlargedIndex = (next + slides.length) % slides.length;
        enlarged.replaceChildren(slides[enlargedIndex].cloneNode(true));
        dialog.querySelector('[data-broth-modal-position]').textContent = `${enlargedIndex + 1} / ${slides.length}`;
      };
      const go = next => {
        index = (next + slides.length) % slides.length;
        track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      const sync = () => {
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        this.querySelector('[data-broth-position]').textContent = `${index + 1} / ${slides.length}`;
        shortcuts.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.brothIndex) === index)));
      };
      this.querySelectorAll('[data-broth-controls]').forEach(control => control.hidden = false);
      this.querySelector('[data-broth-prev]').addEventListener('click', () => go(index - 1));
      this.querySelector('[data-broth-next]').addEventListener('click', () => go(index + 1));
      shortcuts.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.brothIndex))));
      track.addEventListener('scroll', sync, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.querySelector('[data-broth-zoom]').addEventListener('click', () => {
        showEnlarged(index);
        dialog.showModal();
      });
      dialog.querySelector('[data-broth-modal-prev]').addEventListener('click', () => showEnlarged(enlargedIndex - 1));
      dialog.querySelector('[data-broth-modal-next]').addEventListener('click', () => showEnlarged(enlargedIndex + 1));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          showEnlarged(enlargedIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      let touchStart;
      enlarged.addEventListener('touchstart', event => {
        touchStart = event.touches.length === 1 ? event.touches[0] : null;
      }, {passive: true});
      enlarged.addEventListener('touchend', event => {
        if (!touchStart) return;
        const end = event.changedTouches[0];
        const delta = end.clientX - touchStart.clientX;
        if (Math.abs(delta) > 50 && Math.abs(delta) > Math.abs(end.clientY - touchStart.clientY) * 1.3) {
          showEnlarged(enlargedIndex + (delta < 0 ? 1 : -1));
        }
        touchStart = null;
      }, {passive: true});
      enlarged.addEventListener('touchcancel', () => touchStart = null, {passive: true});
      dialog.addEventListener('close', () => go(enlargedIndex));
      this.querySelector('[data-broth-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      this.closest('[data-product-root]').querySelector('[data-broth-benefits-link]')?.addEventListener('click', () => {
        go(1); this.scrollIntoView({behavior: 'auto', block: 'center'}); track.focus({preventScroll: true});
      });
      sync();
    }
  });
}
